import {USER_LIST_FAILED, USER_LIST_LOAD, USER_LIST_LOADING, USER_LIST_SUCCESS} from "../constants/UserListConst";


const initState = {
    loading     : false,
    message     : '',
    showMessage : false,
    page        : 1,
    total       : 0,
    data        : []
}

const userlistreducer = (state = initState, action) => {
    switch (action.type) {
        case USER_LIST_LOADING:
            return {
                ...state,
                loading: true,
            }
        case USER_LIST_FAILED:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case USER_LIST_SUCCESS:
            return {
                ...state,
                showMessage: false,
                data:action.data,
                loading: false
            }
        case USER_LIST_LOAD:
            return {
                ...state,
                page:action.page,
                loading: true,
            }


        default:
            return state;
    }
}

export default userlistreducer